var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.hupUsrs),function(hupUsr){return [(_vm.value === hupUsr.value)?_c('VChip',{key:hupUsr.value,attrs:{"color":hupUsr.color,"label":"","small":""}},[_vm._v(" "+_vm._s(hupUsr.name)+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }